function DragDropHelpers(inputTypes, onChange, inputFieldRef, addFieldRef, withRemove, singleElement, supportedDataTypes, onFieldClick, textConvert) {

    this.inputTypes = inputTypes
    this.onChange = onChange
    this.inputFieldRef = inputFieldRef
    this.addFieldRef = addFieldRef
    this.singleElement = singleElement
    this.onFieldClick = onFieldClick
    this.textConvert = textConvert

    this.dragOver = (e) => {
        if (this.allowDrop) {
            if (this.allowDrop(e)) {
                e.preventDefault()
            }
        } else {
            if (supportedDataTypes) {
                supportedDataTypes.forEach(supportedDataType => {
                    if (supportedDataType === "text") {
                        supportedDataType = "text/plain"
                    }
                    if (e.dataTransfer.types.includes(supportedDataType)) {
                        e.preventDefault()
                        return
                    }
                });
            } else {
                e.preventDefault()
            }
        }
    }


    this.createElementWithRemove = (field, params) => {
        let element = this.createElement(field, params)
        element.addEventListener("dragstart", this.dragStartWithRemoving)
        element.addEventListener("dragend", this.dragEndWithRemoving)

        return element
    }

    this.createElement = (field, params) => {
        let element = document.createElement("input");
        element.type = "button"
        element.value = getName(field)
        element.id = field.id
        element.className = "input-field"
        element.dataset.typeid = field.typeId
        element.dataset.datatype = field.dataType
        if (params) {
            element.dataset.params = params
        }

        element.draggable = true

        if (this.onFieldClick) {
            element.addEventListener("click", this.onFieldClick)
        }

        if (this.textConvert) {            
            this.textConvert(element)
        }

        return element;
    }
    //TODONOW: Make the id of the filed to be composite and split it here. The typeid should be the main type
    this.setDataTransfer = (e, typeId, fieldId) => {
        const type = this.inputTypes.find(a => a.id == typeId)

        let field = this.findField(type, fieldId)

        e.dataTransfer.setData("field", JSON.stringify(field));
        e.dataTransfer.setData(type.application, type.application);
        e.dataTransfer.setData(field.dataType, field.name);
    }

    this.findField = (type, fieldId) => {
        const parts = fieldId.split(".")
        let field
        let path = ""
        for (let i = 0; i < parts.length; i++) {
            const part = path + parts[i]
            path = path + (path === "" ? "" : ".") + parts[i]
            field = type.fields.find(a => a.id === path)
            type = field.subtype
        }
        return field
    }

    this.dragStart = (e) => {
        this.setDataTransfer(e, e.target.dataset.typeid, e.target.id)
    }

    this.dragStartWithRemoving = (e) => {
        this.setDataTransfer(e, e.target.dataset.typeid, e.target.id)
        e.target.className = "input-field dragging"
    }

    this.dragEndWithRemoving = (e) => {
        e.preventDefault();
        var testContainer = document.querySelector('#block');
        var draggingElements = testContainer.querySelectorAll('.dragging')
        if (draggingElements) {
            draggingElements.forEach(element => element.remove())
            this.onChange()
        }
    }

    this.drop = (e) => {
        //TODO: Allow to drop only my elements
        e.preventDefault();

        var field = JSON.parse(e.dataTransfer.getData("field"));

        if (supportedDataTypes && !supportedDataTypes.find(a => field.dataType === a || field.dataType === "text/plain" && a === "text")) {
            return
        }

        let clientX = e.clientX
        let clientY = e.clientY
        if (!clientX) {
            //This is happening in SeleniumIDE
            var viewportOffset = e.currentTarget.getBoundingClientRect()
            clientX = viewportOffset.left + 10
            clientY = viewportOffset.top + 10
        }

        var range = null;
        if (document.caretRangeFromPoint) { // Chrome
            range = document.caretRangeFromPoint(clientX, clientY);
        }
        else if (e.rangeParent) { // Firefox
            range = document.createRange(); range.setStart(e.rangeParent, e.rangeOffset);
        }

        if (singleElement) {
            this.replaceField(field)
        } else {
            this.insertElement(field, range);

            this.onChange()
        }
    }

    this.addField = (field) => {
        this.inputFieldRef.current.focus()
        let range = window.getSelection().getRangeAt(0)
        this.insertElement(field, range);
        this.onChange()

        this.addFieldRef.current.className = "dropdown-menu field-selector"
    }

    this.addFieldForMultiple = (field) => {
        var element = this.createElementWithRemove(field);
        let parent = this.inputFieldRef.current
        parent.appendChild(element)
        this.onChange()

        this.addFieldRef.current.className = "dropdown-menu field-selector"
    }

    this.replaceField = (field) => {
        var element = this.createElementWithRemove(field);
        let parent = this.inputFieldRef.current
        while (parent.firstChild) {
            parent.removeChild(parent.firstChild);
        }
        parent.appendChild(element)
        this.onChange()

        this.addFieldRef.current.className = "dropdown-menu field-selector"
    }

    this.insertElement = (field, range) => {
        var element = this.createElementWithRemove(field);

        var sel = window.getSelection();
        sel.removeAllRanges();
        range.insertNode(element);
        sel.addRange(range);
        sel.removeAllRanges();
    }

    this.readValue = (value) => {
        const reg = /([^{]*)({{([^}^:]+):([^}^:]+):([^}^:]+)(:([^}]+))?}})([^{]*)/g
        //TODONOW: This is working with mongo, but creates problem with all other that have more than one const reg = /(.*[^{]*)({{([^}^:]+):([^}^:]+):([^}^:]+)(:([^}]+))?}})([^{]*)/g
        let html = ""
        var result;
        while ((result = reg.exec(value)) !== null) {
            html += result[1]
            const id = result[3]
            const typeId = result[4]
            //const dataType = result[5]
            const params = result[7]
            const type = inputTypes.find(a => a.id === typeId)
            const field = this.findField(type, id)
            //const field = type.fields.find(a => a.id === id)
            var element = this.createElementWithRemove(field, params);
            html += element.outerHTML
            //html += `<input type="button" value="${field.name}" data-typeid="${typeid}" id="${id}" class="input-field" draggable="true"/>`
            html += result[8]
        }
        if (html === "") {
            html = value
        }
        return html
    }

    this.readValueAndInitializeComponents = (value) => {
        this.inputFieldRef.current.innerHTML = this.readValue(value)
        if (this.onFieldClick) {
            var children = this.inputFieldRef.current.children
            for (var i = 0; i < children.length; i++) {
                var child = children[i]
                child.addEventListener("click", this.onFieldClick)
            }
        }
    }

    if (this.inputFieldRef && this.inputFieldRef.current) {
        if (withRemove) {
            this.inputFieldRef.current.addEventListener("dragstart", this.dragStartWithRemoving);
            this.inputFieldRef.current.addEventListener("dragend", this.dragEndWithRemoving);
        }

        // this.inputFieldRef.current.addEventListener("drop", this.drop);
        // this.inputFieldRef.current.addEventListener("dragover", this.dragOver);
    }
}

export default DragDropHelpers

export const readTextValue = (value, inputTypes) => {
    const reg = /([^{]*)({{([^}^:]+):([^}^:]+):([^}^:]+)(:([^}]+))?}})([^{]*)/g
    let html = ""
    var result;
    while ((result = reg.exec(value)) !== null) {
        html += result[1]
        const id = result[3]
        const typeId = result[4]
        const type = inputTypes.find(a => a.id === typeId)
        const field = findField(type, id)
        if (field) {
            html += "{" + getName(field) + "}"
        }
        html += result[8]
    }
    if (html === "") {
        html = value
    }
    return html
}

export const findField = (type, fieldId) => {
    if (!type) {
        return undefined
    }
    const parts = fieldId.split(".")
    let field
    let path = ""
    for (let i = 0; i < parts.length; i++) {
        const part = path + parts[i]
        path = path + (path === "" ? "" : ".") + parts[i]
        field = type.fields.find(a => a.id === path)
        type = field.subtype
    }
    return field
}

export const replaceFieldsInHtml = (html) => {
    html = html.replace(/&nbsp;/g, " ")
    const reg = /<[^>]*id="([^"]+)"[^>]*data-typeid="([^"]+)"[^>]*data-datatype="([^"]+)"[^>]*(data-params="([^"]+)"[^>]*)?>/g
    var result;
    const regHtml = html
    if (regHtml.includes("data-params")) {
        const regParams = /<[^>]*id="([^"]+)"[^>]*data-typeid="([^"]+)"[^>]*data-datatype="([^"]+)"[^>]*draggable="true"[^>]*data-params="([^"]+)"?[^>]*>/g
        while ((result = regParams.exec(regHtml)) !== null) {
            if (result[4]) {
                html = html.replace(result[0], '{{' + result[1] + ':' + result[2] + ':' + result[3] + ':' + result[4] + '}}')
            }
        }
    } 

    while ((result = reg.exec(regHtml)) !== null) {
        if (result[5]) {
            html = html.replace(result[0], '{{' + result[1] + ':' + result[2] + ':' + result[3] + ':' + result[5] + '}}')
        } else {
            html = html.replace(result[0], '{{' + result[1] + ':' + result[2] + ':' + result[3] + '}}')
        }
    }

    return html
}

export const parseFields = (value) => {
    const reg = /([^{]*)({{([^}^:]+):([^}^:]+):([^}^:]+)(:([^}]+))?}})([^{]*)/g
    let items = []
    var result;
    while ((result = reg.exec(value)) !== null) {
        items.push({
            id: result[3],
            typeId: result[4],
            dataType: result[5],
            params: result[7]
        })
    }

    return items
}

export const getName = (field) => {
    if (field.name != null) {
        return field.name
    }
    let name = ""
    let parts = field.id.split(".")
    for (let i = 0; i < parts.length; i++) {
        var part = parts[i];

        if (i == 0 && part === "data") {
            //TODONOW: This is specific to Asana, move it in the json
            continue
        }
        part = part.split('_').join(' ')

        let words = part.split(/(?=[A-Z])/)
        if (name !== "") {
            name += " "
        }
        name += words[0].charAt(0).toUpperCase() + words[0].slice(1)
        if (words.length > 1) {
            for (let i = 1; i < words.length; i++) {
                const word = words[i]
                if (word.length === 1) {
                    name += word
                    //We have abreviation
                } else {
                    if (name !== "") {
                        name += " "
                    }
                    name += word.charAt(0).toLowerCase() + word.slice(1)
                }
            }
        }

        // name += words.join(" ")
    }
    return name
}

export const removeFieldsUsedInParams = (params) => {
    Object.entries(params).forEach(([stepId, values]) => removeFieldsUsedInValues(params, stepId, values));
}

const removeFieldsUsedInValues = (params, stepId, values) => {
    if (values) {
        const valueType = typeof values
        if (valueType === 'object') {
            Object.entries(values).forEach(([key, value]) => {
                removeFieldsUsedInValues(values, key, value)
            });
        } else if (valueType === 'string') {
            const newValue = removeFields(values)
            if (newValue || !newValue.trim() === "") {
                params[stepId] = newValue
            } else {
                delete params[stepId]
            }
        }
    } else {
        delete params[stepId]
    }
}

const removeFields = (value) => {
    const reg = /([^{]*)({{([^}]+):([^}]+)}})([^{]*)/g
    return value.replace(reg, '');
}
